import React from "react";
import { Typography, Link, Tooltip } from "@mui/material";
import WidgetCard from "../components/WidgetCard.tsx";
import { fpColors } from "../../../theme/fpTheme.ts";

const WelcomeCardWidget = () => {
  return (
    <WidgetCard title="Welcome to FreightPlus One">
      <ul style={{ margin: 0, paddingLeft: "20px" }}>
        <li>
          <Link
            href="https://freightplus.atlassian.net/wiki/external/ZGNlNzQzNWQyYzA3NGJjOGEyNjllMzMwMTQzMDgyYzg"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: fpColors.hyperlinkblue }}
          >
            <Typography variant="body2">Getting Started</Typography>
          </Link>
        </li>
        <li>
          <Link
            href="https://freightplus.atlassian.net/wiki/external/YjQ2ZDcyOGQ3NDhlNDEzZjk0MDk0ODgzOTczOWY1ZTA"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: fpColors.hyperlinkblue }}
          >
            <Typography variant="body2">What is a Beta Program?</Typography>
          </Link>
        </li>
        <li>
          <Tooltip title="clientmanagement@freightplus.io" arrow>
            <Link
              href="mailto:clientmanagement@freightplus.io"
              sx={{ color: fpColors.hyperlinkblue }}
            >
              <Typography variant="body2">Contact Us</Typography>
            </Link>
          </Tooltip>
        </li>
      </ul>
    </WidgetCard>
  );
};

export default WelcomeCardWidget;
